// extracted by mini-css-extract-plugin
module.exports = {"garlandMain":"HolidayGarland_garlandMain__3tfk6","garlandCointainer":"HolidayGarland_garlandCointainer__3fPoy"};